import { DefaultRootState } from 'react-redux';

interface MutateParams {
    noTrl?: boolean;
}

const trlMutator = (data: DefaultRootState, params: MutateParams) => {
    if (!data?.trl) {
        return data;
    }
    Object.entries(data.trl).forEach(([lang, trlsByLang]) =>
        Object.entries(trlsByLang).forEach(([key, value]) => {
            trlsByLang[key] = params.noTrl
                ? `[${lang}:${key}]`
                : value.replace(/&#(\d+);/g, (_, code) => String.fromCharCode(code as number));
        })
    );
    return data;
};

const mutators = [trlMutator];

const mutate = (data: DefaultRootState, params: MutateParams = {}): DefaultRootState =>
    mutators.reduce((data, mutator) => mutator(data, params), data);

export default mutate;
